import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import EditableRow from './EditableRow';
/* import EditModal from './EditModal'; */
import DeleteConfirmationModal from 'routes/Pages/FichasTecnicas/Components/DeleteConfirmationModal';
import { reformatDateYYYYmmDD } from 'routes/Pages/FichasTecnicas/ConstsAndUtils/utils';
import EditModal2 from './EditModal2';
import { TEXT_COLOR_FT } from 'config/config';
import { Grid, InputAdornment, TextField } from '@material-ui/core';
import { Search } from '@material-ui/icons';

const useStyles = makeStyles({
  table: {
    minWidth: 650,
   // border: 'solid 1px',
    borderColor: '#e0e0e0'
  },
});

const DataTable = ({ headCells, rows, tiposAux, autoridadesAux, estadosAux, garantia, handleSave, handleDelete, fields, isEquip, dataExtra, isCentroDependiente, espacios,
  isGeneralIndiferenciada, mantencionAux, isOdonto,
}) => {
  const classes = useStyles();
  const [editRowIndex, setEditRowIndex] = useState(null);
  const [editedRowData, setEditedRowData] = useState({});
  const [openModal, setOpenModal] = useState(false)

  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  const [searchQuery, setSearchQuery] = useState('');


  const [showModalDelete, setShowModalDelete] = useState(false)
  const [dataToDelete, setDataToDelete] = useState('')

  const [checkedHorario, setCheckHorario] = useState(false)

  const handleChange = () => {
    setCheckHorario(!checkedHorario)
  }


  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const filteredRows = rows.filter((row) => {
    return Object.values(row).some((value) =>
      value?.toString().toLowerCase().includes(searchQuery.toLowerCase())
    );
  });

  const handleSort = (key) => {
    setSortConfig((prev) => ({
      key,
      direction: prev.key === key && prev.direction === 'asc' ? 'desc' : 'asc',
    }));
  };

  const sortedRows = React.useMemo(() => {
    if (!sortConfig.key) return filteredRows;

    return [...filteredRows].sort((a, b) => {
      if (a[sortConfig.key] < b[sortConfig.key]) {
        return sortConfig.direction === 'asc' ? -1 : 1;
      }
      if (a[sortConfig.key] > b[sortConfig.key]) {
        return sortConfig.direction === 'asc' ? 1 : -1;
      }
      return 0;
    });
  }, [filteredRows, sortConfig]);

  const openModalDelete = (rowIndex) => {
    setShowModalDelete(true)
    let aux = {
      header: rows[rowIndex]['nombre'],
      nombre: rows[rowIndex]['nombre'],
      id: rows[rowIndex]['id']
    }

    setDataToDelete(aux)
  }

  const closeModal = () => {
    setCheckHorario(false)
    setOpenModal(false)
    setEditRowIndex(null);
  }

  const getIdEdoInt = (name) => {
    if (name) {
      let foundEdoAutSanit = estadosAux.find(e => e.label === name)
      return foundEdoAutSanit.value
    } else {
      return 0
    }
  }

  const getIdautId = (name) => {
    if (name) {
      let foundAutoridad = autoridadesAux.find(e => e.label === name)
      return foundAutoridad.value
    } else {
      return 0
    }
  }

  const getIdTipoServ = (name) => {
    if (name) {
      let foundType = tiposAux.find(e => e.label === name)
      return foundType.value
    } else {
      return 0
    }
  }

  const dateData = (data) => {

    if (data) {
      return reformatDateYYYYmmDD(data)
    } else {
      return ''
    }


  }

  const handleEditClick = (index) => {

    let auxData = {
      ...rows[index],
      id_edo_aut_sanitaria: rows[index]['id_edo_aut_sanitaria'] ? getIdEdoInt(rows[index]['id_edo_aut_sanitaria']) : null,
      id_autoridad: rows[index]['id_autoridad'] ? getIdautId(rows[index]['id_autoridad']) : '',
      id_tipo_servicio: rows[index]['id_tipo_servicio'] ? getIdTipoServ(rows[index]['id_tipo_servicio']) : null
    }

    if (rows[index]['fecha_resolucion']) {
      auxData['fecha_resolucion'] = dateData(rows[index]['fecha_resolucion'])
    }

    if (isEquip) {
      delete auxData.equipamiento
      delete auxData.id_ficha_tecnica
      delete auxData.id_edo_aut_sanitaria
    }

    setEditRowIndex(index);

    const keysToCheck = [
      "e_lunes_jueves", "s_lunes_jueves", "t_lunes_jueves",
      "e_viernes", "s_viernes", "t_viernes",
      "e_sabados", "s_sabados", "t_sabados",
      "e_domingos", "s_domingos", "t_domingos",
      "e_festivos", "s_festivos", "t_festivos"
    ];



    if (auxData.data_extra) {
      const hasAnyData = keysToCheck.some(key => {
        const value = auxData.data_extra[key];
        return value !== null && value !== undefined && value !== "";
      });
      if (hasAnyData) {
        setCheckHorario(true)
      }
      //setCheckHorario(true)
    }
    setEditedRowData(auxData);

    setOpenModal(true)
  };

  const closeModalDelete = () => {
    setShowModalDelete(false)
  }

  const handleSaveClick = () => {

    // handleSave(editedRowData)
    // setEditRowIndex(null);
  };

  const handleDeleteClick = () => {
    handleDelete(dataToDelete)
    closeModalDelete()
  }

  const handleInputChange = (e, id, type) => {

    switch (type) {
      case 'number': const regexNumber = /^[0-9]+$/;
        if (regexNumber.test(e.target.value) || e.target.value === '') {
          if (e.target.value.length < 12) {
            setEditedRowData({ ...editedRowData, [id]: e.target.value });
          }
        }
        break
      default: if (e.target.value.length < 100) {
        setEditedRowData({ ...editedRowData, [id]: e.target.value });
      }
        break
    }
  };

  return (
    <>
      <Grid xs={12} container item justifyContent='flex-end' style={{padding:0}}>

        <TextField
          size='small'
          label="Buscar"
          variant="outlined"
          value={searchQuery}
          onChange={handleSearchChange}
          style={{ marginBottom: 5 }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <Search />
              </InputAdornment>
            ),
          }}
        />

      </Grid>
      <TableContainer >
        <Table className={classes.table} aria-label="simple table" size='small'>
          <TableHead style={{backgroundColor:"#f4f4f7",  }}>
            <TableRow>
              {headCells.map((headCell) => {

                if (headCell.shown) {
                  return (
                    <TableCell
                      key={headCell.id}
                      align={headCell.align || 'left'}
                      style={{ color: TEXT_COLOR_FT, cursor: 'pointer' }}
                      onClick={() => { handleSort(headCell.id) }}
                    >
                      <Grid container alignItems='center'>
                        <Grid container item xs={11}>
                          {headCell.label}
                        </Grid>
                        <Grid container item xs={1}>
                          <span>
                            {sortConfig.key === headCell.id
                              ? sortConfig.direction === 'asc'
                                ? ' 🔼'
                                : ' 🔽'
                              : ''}
                          </span>
                        </Grid>
                      </Grid>


                    </TableCell>
                  )
                } else {
                  return null
                }
              })}
              <TableCell align="center">Acciones</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {sortedRows.map((row, rowIndex) => (
              <EditableRow
                key={rowIndex}
                row={editRowIndex === rowIndex ? editedRowData : row}
                headCells={headCells}
                //isEditing={editRowIndex === rowIndex}
                isEditing={false}
                //isEditable={editRowIndex === null}
                isEditable={true}
                onInputChange={(e, id, type) => handleInputChange(e, id, type)}
                onSave={handleSaveClick}
                onDelete={() => openModalDelete(rowIndex)}
                onEdit={() => handleEditClick(rowIndex)}
                tiposAux={tiposAux}
                autoridadesAux={autoridadesAux}
                estadosAux={estadosAux}
                garantia={garantia}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <EditModal2
        espacios={espacios}
        isCentroDependiente={isCentroDependiente}
        openDialog={openModal}
        close={closeModal}
        dataCrear={editedRowData}
        setDataCrear={setEditedRowData}
        fields={fields}
        postData={handleSave}
        estadosAux={estadosAux}
        tiposAux={tiposAux}
        autoridadesAux={autoridadesAux}
        garantia={garantia}
        isEquip={isEquip}
        dataExtra={dataExtra}
        isGeneralIndiferenciada={isGeneralIndiferenciada}
        mantencionAux={mantencionAux}
        isOdonto={isOdonto}
        checked={checkedHorario}
        handleChange={handleChange}

      />
      <DeleteConfirmationModal
        openDialog={showModalDelete}
        close={closeModalDelete}
        postData={handleDeleteClick}
        deleteData={dataToDelete}
        loading={false}
      />
    </>

  );
};

DataTable.propTypes = {
  headCells: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      align: PropTypes.oneOf(['left', 'right', 'center', 'justify']),
    })
  ).isRequired,
  rows: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default DataTable;
